import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { yupLocalized } from "@ryde/shared";

import { BulkPassengerNearbySearchFormFieldsEnum } from "../models";

export const useBulkPassengerNearbySearchFormValidation = () => {
  const { t } = useTranslation();
  const bulkPassengerNearbySearchFormValidation = useMemo(() => {
    const distanceInMetersPath = t(
      `passenger.formLabel.${BulkPassengerNearbySearchFormFieldsEnum.distanceInMeters}`,
    );
    return {
      [BulkPassengerNearbySearchFormFieldsEnum.distanceInMeters]: yupLocalized
        .number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value,
        )
        .typeError(t("validation.numberOnly", { path: distanceInMetersPath }))
        .positive(t("validation.positive", { path: distanceInMetersPath }))
        .integer(t("validation.integer", { path: distanceInMetersPath }))
        .optional(),
    };
  }, [t]);

  return { bulkPassengerNearbySearchFormValidation };
};
